import Component from "@base/js/component";

export default class Chips extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".chips";

  // Defines children that needs to be queried as part of this component
  static children = {
    content: ".chips__content",
    template: ".chips__template",
  };

  // Defines sub components that needs to be queried as part of this component
  static members = {
    // subComponent: ComponentClass, // Maps as a single subcomponent instance
    // subComponents: [ComponentClass], // Maps as an array of subcomponent instances
  };

  // Current items
  items = [];

  add(itemData) {
    if (itemData.key && itemData.value) {
      const itemElement = this.generateItem(itemData);
      this.children.content.appendChild(itemElement);
      this.items.push(itemData);

      // Dispatch itemadd event
      const customEvent = new window.CustomEvent("itemadd", {
        detail: itemData,
      });
      this.element.dispatchEvent(customEvent);
    }
  }

  getChipData(itemValue) {
    const index = this.items.findIndex((item) => item.value === itemValue);

    if (index > -1) {
      return this.items[index];
    }

    return null;
  }

  generateItem(itemData) {
    const itemElement =
      this.children.template.content.firstElementChild.cloneNode(true);
    const text = itemElement.querySelector(".chips__text");
    const removeButton = itemElement.querySelector(".chips__remove");

    text.textContent = itemData.text; // .chips__text
    itemElement.dataset.value = itemData.value;
    itemElement.dataset.key = itemData.key;

    removeButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.remove(itemData.key, itemData.value);
    });

    return itemElement;
  }

  remove(key, value, quiet = false) {
    const index = this.items.findIndex(
      (item) => item.key === key && item.value === value
    );

    if (index > -1) {
      const [removedItem] = this.items.splice(index, 1);

      // Remove element
      const elementToRemove = this.children.content.children[index];
      this.children.content.removeChild(elementToRemove);

      if (!quiet) {
        // Dispatch itemremove event
        const customEvent = new window.CustomEvent("itemremove", {
          detail: removedItem,
        });
        this.element.dispatchEvent(customEvent);
      }
    }
  }

  // Adds itemadd callback
  onAdd(callback) {
    this.element.addEventListener("itemadd", ({ detail }) => callback(detail));
  }

  // Adds itemremove callback
  onRemove(callback) {
    this.element.addEventListener("itemremove", ({ detail }) =>
      callback(detail)
    );
  }

  // Adds clear callback
  onClear(callback) {
    this.element.addEventListener("clear", ({ detail }) => callback(detail));
  }

  clear() {
    [...this.items].forEach((item) => {
      this.remove(item.key, item.value, true);
    });

    // Dispatch clear event
    const customEvent = new window.CustomEvent("clear");
    this.element.dispatchEvent(customEvent);
  }

  // Will be called upon component instantiation
  // afterInit() {
  //   /* eslint-disable no-console */
  //   console.log(`Component initialized`, this.element);
  //   /* eslint-enable no-console */
  // }
}
